import { render, staticRenderFns } from "./PictureViewer.vue?vue&type=template&id=67bcf08f&scoped=true&"
var script = {}
import style0 from "./PictureViewer.vue?vue&type=style&index=0&id=67bcf08f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67bcf08f",
  null
  
)

export default component.exports